import { actionTypes, AvisoStatus, AvisoState, initialState, AvisoActions } from './types'

const AvisoReducer = (state: AvisoState = initialState, action: AvisoActions): AvisoState => {
  switch (action.type) {
    case actionTypes.GET_AVISO:
      return {
        ...state,
        status: AvisoStatus.Loading,
      }
    case actionTypes.GET_AVISO_SUCCESS:
      return {
        ...state,
        aviso: action.payload,
        status: AvisoStatus.Success,
      }
    case actionTypes.GET_AVISO_ERROR:
      return {
        ...state,
        aviso: null,
        status: AvisoStatus.Error,
      }
    case actionTypes.GET_AVISO_RESET:
      return {
        ...state,
        aviso: null,
        status: AvisoStatus.Idle,
      }
    default:
      return state
  }
}
export default AvisoReducer
